import { App } from "../../_app";

export class Lazy {

    static init(): void {
        const screenWidth: number = window.innerWidth || $(window).width();

        const lazyMobileItems = document.getElementsByClassName("lazyMobile") as HTMLCollectionOf<HTMLDivElement>;
        Array.from(lazyMobileItems).forEach(div => {
            div.style.backgroundImage = div.getAttribute("data-src");
        });

        const lazyItems = document.getElementsByClassName("lazy") as HTMLCollectionOf<HTMLDivElement>;
        Array.from(lazyItems).forEach(item => {
            
            // hasclass dv-channel-image immer
            if (item.classList.contains("dv-channel-image")) {
                item.style.backgroundImage = "url(" + item.getAttribute("data-src") + ")";

            }
            // hasbclass dv-background-image nur wenn 1024 
            if (screenWidth >= 1024) {
                if (item.classList.contains("dv-background-image") ||
                    item.classList.contains("dv-footer-background-image")) {

                    item.style.backgroundImage = "url(" + item.getAttribute("data-src") + ")";
                    item.classList.remove("no-bg");
                    Lazy.setHeader(true);
                } else {                    
                    item.classList.add("no-bg");
                    Lazy.setHeader(false);
                }
            }
        });
        App.Common.Functions.dockCommunicationWidgetToFooter();

    }
    private static setHeader(colorOrNot: boolean) {
        const headers = document.getElementsByClassName("header-color") as HTMLCollectionOf<HTMLHeadingElement>;
        Array.from(headers).forEach(header => {
            header.style.color = colorOrNot ? header.getAttribute("data-color") : "unset";
        });
    }
}